var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "code-snippet grid grid__base" }, [
    _vm.title
      ? _c("div", { staticClass: "grid--container" }, [
          _c("h2", { staticClass: "code-snippet--title" }, [
            _vm._v(_vm._s(_vm.title))
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { ref: "code", staticClass: "code-snippet--code" })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35923af8", { render: render, staticRenderFns: staticRenderFns })
  }
}